export interface GoogleMapsLocation {
  address?: string;
  latitude?: string | number | null;
  longitude?: string | number | null;
}

function parseCoordinate(value?: string | number | null) {
  if (value === null || value === undefined || String(value).trim() === '') {
    return undefined;
  }

  const coordinate = Number(value);
  return Number.isFinite(coordinate) ? coordinate : undefined;
}

export function buildGoogleMapsUrl({ address, latitude, longitude }: GoogleMapsLocation) {
  const parsedLatitude = parseCoordinate(latitude);
  const parsedLongitude = parseCoordinate(longitude);
  const query =
    parsedLatitude !== undefined && parsedLongitude !== undefined
      ? `${parsedLatitude},${parsedLongitude}`
      : address?.trim();

  if (!query) {
    return null;
  }

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}
